import script from "./DVIResults.vue?vue&type=script&lang=ts&setup=true"
export * from "./DVIResults.vue?vue&type=script&lang=ts&setup=true"

import "./DVIResults.vue?vue&type=style&index=0&id=5eeba27c&lang=css"

const __exports__ = script;

export default __exports__